import { render, staticRenderFns } from "./PayerHeader.vue?vue&type=template&id=46eb45cb&scoped=true"
import script from "./PayerHeader.vue?vue&type=script&lang=js"
export * from "./PayerHeader.vue?vue&type=script&lang=js"
import style0 from "./PayerHeader.vue?vue&type=style&index=0&id=46eb45cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eb45cb",
  null
  
)

export default component.exports